import React from "react";
import { useSelector } from 'react-redux';
import _ from "lodash";
import { Tooltip } from "antd";
import { getIconMutedColor } from '../../utils/helpers';
import "./commentLabelIndicator.scss";

const CommentLabelIndicator = ({ commentsCount, openCommentsTab }) => {
  const themeDark = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  return (
    <Tooltip
      placement="top"
      title={commentsCount ? `${commentsCount} Comments` : 'Comments'}
      style={{ cursor: "pointer" }}
      overlayInnerStyle={{
        fontSize: "13px",
      }}
    >
      <button
        className="CommentLabelIndicator center"
        onClick={
          !commentsCount
            ? () => {
                return false;
              }
            : openCommentsTab
        }
        style={{
          cursor: !commentsCount ? "default" : "pointer",
        }}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <g clipPath="url(#clip0_6994_6517)">
            <path
              d="M11 0.75H1C0.801088 0.75 0.610322 0.829018 0.46967 0.96967C0.329018 1.11032 0.25 1.30109 0.25 1.5V8.275C0.250629 8.37215 0.270643 8.4682 0.30887 8.55751C0.347097 8.64683 0.402768 8.72761 0.472619 8.79514C0.54247 8.86266 0.625096 8.91556 0.715655 8.95074C0.806215 8.98592 0.902885 9.00266 1 9H2.5V11C2.49921 11.0457 2.51149 11.0907 2.53541 11.1297C2.55932 11.1687 2.59388 11.2 2.635 11.22C2.673 11.2445 2.71727 11.2576 2.7625 11.2576C2.80773 11.2576 2.852 11.2445 2.89 11.22L6.08 9H11C11.1989 9 11.3897 8.92098 11.5303 8.78033C11.671 8.63968 11.75 8.44891 11.75 8.25V1.5C11.75 1.30109 11.671 1.11032 11.5303 0.96967C11.3897 0.829018 11.1989 0.75 11 0.75ZM9.5 5C9.5 5.14834 9.45601 5.29334 9.3736 5.41668C9.29119 5.54001 9.17406 5.63614 9.03701 5.69291C8.89997 5.74968 8.74917 5.76453 8.60368 5.73559C8.4582 5.70665 8.32456 5.63522 8.21967 5.53033C8.11478 5.42544 8.04335 5.2918 8.01441 5.14632C7.98547 5.00083 8.00033 4.85003 8.05709 4.71299C8.11386 4.57594 8.20999 4.45881 8.33332 4.3764C8.45666 4.29399 8.60166 4.25 8.75 4.25C8.94891 4.25 9.13968 4.32902 9.28033 4.46967C9.42098 4.61032 9.5 4.80109 9.5 5ZM2.5 5C2.5 4.85166 2.54399 4.70666 2.6264 4.58332C2.70881 4.45999 2.82594 4.36386 2.96299 4.30709C3.10003 4.25032 3.25083 4.23547 3.39632 4.26441C3.5418 4.29335 3.67544 4.36478 3.78033 4.46967C3.88522 4.57456 3.95665 4.7082 3.98559 4.85368C4.01453 4.99917 3.99968 5.14997 3.94291 5.28701C3.88614 5.42406 3.79001 5.54119 3.66668 5.6236C3.54334 5.70601 3.39834 5.75 3.25 5.75C3.05109 5.75 2.86032 5.67098 2.71967 5.53033C2.57902 5.38968 2.5 5.19891 2.5 5ZM5.25 5C5.25 4.85166 5.29399 4.70666 5.3764 4.58332C5.45881 4.45999 5.57594 4.36386 5.71299 4.30709C5.85003 4.25032 6.00083 4.23547 6.14632 4.26441C6.2918 4.29335 6.42544 4.36478 6.53033 4.46967C6.63522 4.57456 6.70665 4.7082 6.73559 4.85368C6.76453 4.99917 6.74968 5.14997 6.69291 5.28701C6.63614 5.42406 6.54001 5.54119 6.41668 5.6236C6.29334 5.70601 6.14834 5.75 6 5.75C5.80109 5.75 5.61032 5.67098 5.46967 5.53033C5.32902 5.38968 5.25 5.19891 5.25 5Z"
              fill={!commentsCount ? getIconMutedColor(themeDark) : "#61CD9A"}
            />
          </g>
          <defs>
            <clipPath id="clip0_6994_6517">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </Tooltip>
  );
};

export default CommentLabelIndicator;
